<div class="signup-container">
  <div class="flex flex-col gap-0 signup-card">
    <div class="public-forms-header mb-3">
      <a href="https://www.brandshelter.com">
        <img alt="Logo" [src]="logoUrl()">
      </a>
      <a class="text-white" [routerLink]="['/login']" i18n="signup|Back to login link">Back to login</a>
    </div>

    @if (showConfirmationMessage) {
      <div class="my-4 mx-auto">
        <h1 class="text-center" i18n="signup|Thank you for your registration at BrandShelter">Thank you for your registration at BrandShelter</h1>
        <p class="text-center mt-3" i18n="signup|We will contact you shortly">We will contact you shortly</p>
      </div>
    } @else {
      <div class="p-4">
        @if (hasServerErrors) {
          <div class="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
            @for (errorKey of serverErrorKeys; track errorKey) {
              <div>{{ errorKey }}: {{ serverErrors[errorKey] }}</div>
            }
          </div>
        }

        <form [formGroup]="form" class="flex flex-col gap-5" (ngSubmit)="onSubmit()">
          <div class="flex flex-row gap-4">
            <div class="flex-1 flex flex-col gap-4">
              <div class="flex flex-col gap-1">
                <label for="signup-title" i18n="signup|Title field label">Title</label>
                <p-select inputId="signup-title" formControlName="title" [options]="titleOptions" placeholder="Select title" [fluid]="true" />
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-firstname" i18n="signup|First name field label">First name</label>
                <input pInputText id="signup-firstname" formControlName="firstname" [invalid]="submitted && form.get('firstname')?.errors" />
                @if (submitted && form.get('firstname')?.errors) {
                  <div>
                    @if (form.get('firstname')?.errors?.['required']) {
                      <div i18n="signup|First name required error">First name is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-lastname" i18n="signup|Last name field label">Last name</label>
                <input pInputText id="signup-lastname" formControlName="lastname" [invalid]="submitted && form.get('lastname')?.errors" />
                @if (submitted && form.get('lastname')?.errors) {
                  <div>
                    @if (form.get('lastname')?.errors?.['required']) {
                      <div i18n="signup|Last name required error">Last name is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-company" i18n="signup|Organization field label">Organization</label>
                <input pInputText id="signup-company" formControlName="company" [invalid]="submitted && form.get('company')?.errors" />
                @if (submitted && form.get('company')?.errors) {
                  <div>
                    @if (form.get('company')?.errors?.['required']) {
                      <div i18n="signup|Organization required error">Organization is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-street" i18n="signup|Street field label">Street</label>
                <input pInputText id="signup-street" formControlName="street" [invalid]="submitted && form.get('street')?.errors" />
                @if (submitted && form.get('street')?.errors) {
                  <div>
                    @if (form.get('street')?.errors?.['required']) {
                      <div i18n="signup|Street required error">Street is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-zip" i18n="signup|Zip field label">Zip</label>
                <input pInputText id="signup-zip" formControlName="zip" [invalid]="submitted && form.get('zip')?.errors" />
                @if (submitted && form.get('zip')?.errors) {
                  <div>
                    @if (form.get('zip')?.errors?.['required']) {
                      <div i18n="signup|Zip required error">Zip is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-city" i18n="signup|City field label">City</label>
                <input pInputText id="signup-city" formControlName="city" [invalid]="submitted && form.get('city')?.errors" />
                @if (submitted && form.get('city')?.errors) {
                  <div>
                    @if (form.get('city')?.errors?.['required']) {
                      <div i18n="signup|City required error">City is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-country" i18n="signup|Country field label">Country</label>
                <p-select inputId="signup-country" formControlName="country" [options]="countryOptions" placeholder="Select country" [fluid]="true" (onChange)="fetchCountryStates($event)" [invalid]="submitted && form.get('country')?.errors" />
                @if (submitted && form.get('country')?.errors) {
                  <div>
                    @if (form.get('country')?.errors?.['required']) {
                      <div i18n="signup|Country required error">Country is required</div>
                    }
                    @if (form.get('country')?.errors?.['serverError']) {
                      <div>{{ form.get('country')?.errors?.['serverError'] }}</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-state" i18n="signup|State field label">State</label>
                <p-select inputId="signup-state" formControlName="country_state" [options]="stateOptions" placeholder="Select state" [fluid]="true" [invalid]="submitted && form.get('country_state')?.errors" />
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-phone" i18n="signup|Telephone number field label">Telephone Number</label>
                <input pInputText id="signup-phone" formControlName="phone" [invalid]="submitted && form.get('phone')?.errors" />
                @if (submitted && form.get('phone')?.errors) {
                  <div>
                    @if (form.get('phone')?.errors?.['required']) {
                      <div i18n="signup|Telephone number required error">Telephone Number is required</div>
                    }
                    @if (form.get('phone')?.errors?.['pattern']) {
                      <div i18n="signup|Telephone number format error">Telephone Number must be in the format +[country code].[number], e.g. +1.123456789</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-cellphone" i18n="signup|Cellphone field label">Cellphone</label>
                <input pInputText id="signup-cellphone" formControlName="cell_phone" [invalid]="submitted && form.get('cell_phone')?.errors" />
                @if (submitted && form.get('cell_phone')?.errors) {
                  <div>
                    @if (form.get('cell_phone')?.errors?.['required']) {
                      <div i18n="signup|Cellphone required error">Cellphone is required</div>
                    }
                  </div>
                }
              </div>
            </div>

            <div class="flex-1 flex flex-col gap-4">
              <div class="flex flex-col gap-1">
                <label for="signup-email" i18n="signup|Email field label">Email</label>
                <input pInputText id="signup-email" formControlName="email" [invalid]="submitted && form.get('email')?.errors" autocomplete="off" />
                @if (submitted && form.get('email')?.errors) {
                  <div>
                    @if (form.get('email')?.errors?.['required']) {
                      <div i18n="signup|Email required error">Username is required</div>
                    }
                    @if (form.get('email')?.errors?.['serverError']) {
                      <div>{{ form.get('email')?.errors?.['serverError'] }}</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-password" i18n="signup|Password field label">Password</label>
                <p-password inputId="signup-password" [toggleMask]="true" [feedback]="true" formControlName="password" [fluid]="true" [invalid]="submitted && form.get('password')?.errors" autocomplete="new-password" />
                @if (submitted && form.get('password')?.errors) {
                  <div>
                    @if (form.get('password')?.errors?.['required']) {
                      <div i18n="signup|Password required error">Password is required</div>
                    }
                    @if (form.get('password')?.errors?.['minlength']) {
                      <div i18n="signup|Password min length error">Password requires at least 12 characters</div>
                    }
                    @if (form.get('password')?.errors?.['pattern']) {
                      <div i18n="signup|Password pattern error">Password requires at least 1 lowercase letter, 1 uppercase letter, 1 digit and 1 special character</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-password-confirmation" i18n="signup|Password confirmation field label">Password Confirmation</label>
                <p-password inputId="signup-password-confirmation" [toggleMask]="true" [feedback]="false" formControlName="password_confirmation" [fluid]="true" [invalid]="submitted && form.get('password_confirmation')?.errors" />
                @if (submitted && form.get('password_confirmation')?.errors) {
                  <div>
                    @if (form.get('password_confirmation')?.errors?.['required']) {
                      <div i18n="signup|Password confirmation required error">Password confirmation is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-commercial-register" i18n="signup|Commercial register number field label">Commercial Register Number</label>
                <input pInputText id="signup-commercial-register" formControlName="commercial_register_number" [invalid]="submitted && form.get('commercial_register_number')?.errors" />
                @if (submitted && form.get('commercial_register_number')?.errors) {
                  <div>
                    @if (form.get('commercial_register_number')?.errors?.['required']) {
                      <div i18n="signup|Commercial register number required error">Commercial Register Number is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-id-card" i18n="signup|Identity card number field label">Identity Card Number</label>
                <input pInputText id="signup-id-card" formControlName="id_card_number" [invalid]="submitted && form.get('id_card_number')?.errors" />
                @if (submitted && form.get('id_card_number')?.errors) {
                  <div>
                    @if (form.get('id_card_number')?.errors?.['required']) {
                      <div i18n="signup|Identity card number required error">Identity Card Number is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-tax-company" i18n="signup|Tax number company field label">Tax Number (Company)</label>
                <input pInputText id="signup-tax-company" formControlName="tax_number_company" [invalid]="submitted && form.get('tax_number_company')?.errors" />
                @if (submitted && form.get('tax_number_company')?.errors) {
                  <div>
                    @if (form.get('tax_number_company')?.errors?.['required']) {
                      <div i18n="signup|Tax number company required error">Tax Number (Company) is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-tax-personal" i18n="signup|Tax number personal field label">Tax Number (Personal)</label>
                <input pInputText id="signup-tax-personal" formControlName="tax_number_personal" [invalid]="submitted && form.get('tax_number_personal')?.errors" />
                @if (submitted && form.get('tax_number_personal')?.errors) {
                  <div>
                    @if (form.get('tax_number_personal')?.errors?.['required']) {
                      <div i18n="signup|Tax number personal required error">Tax Number (Personal) is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-passphrase" i18n="signup|Security question field label">Security Question</label>
                <input pInputText id="signup-passphrase" formControlName="passphrase" [invalid]="submitted && form.get('passphrase')?.errors" />
                @if (submitted && form.get('passphrase')?.errors) {
                  <div>
                    @if (form.get('passphrase')?.errors?.['required']) {
                      <div i18n="signup|Security question required error">Passphrase is required</div>
                    }
                  </div>
                }
              </div>

              <div class="flex flex-col gap-1">
                <label for="signup-answer" i18n="signup|Matching answer field label">Matching Answer</label>
                <input pInputText id="signup-answer" formControlName="answer" [invalid]="submitted && form.get('answer')?.errors" />
                @if (submitted && form.get('answer')?.errors) {
                  <div>
                    @if (form.get('answer')?.errors?.['required']) {
                      <div i18n="signup|Matching answer required error">Matching Answer is required</div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>

          <div class="flex flex-col gap-2">
            <div class="flex flex-col gap-1">
              <div class="flex flex-row gap-2">
                <p-checkbox inputId="signup-accept-dpa" formControlName="accept_dpa" [binary]="true" [invalid]="submitted && form.get('accept_dpa')?.errors" />
                <label class="form-check-label" for="signup-accept-dpa" i18n="signup|Accept DPA checkbox">
                  I acknowledge and accept
                  <a href="{{ dataProcessingAgreementUrl() }}" target="_blank" rel="noopener noreferrer">BrandShelter's Data Processing Agreement</a>
                </label>
              </div>
              @if (submitted && form.get('accept_dpa')?.errors) {
                <div>
                  @if (form.get('accept_dpa')?.errors?.['required']) {
                    <div i18n="signup|Accept DPA required error">You must accept the Data Processing Agreement</div>
                  }
                </div>
              }
            </div>
            <div class="flex flex-col gap-1">
              <div class="flex flex-row gap-2">
                <p-checkbox inputId="signup-accept-privacy" formControlName="accept_privacy_policy" [binary]="true" [invalid]="submitted && form.get('accept_privacy_policy')?.errors" />
                <label class="form-check-label" for="signup-accept-privacy" i18n="signup|Accept privacy policy checkbox">
                  I acknowledge and accept
                  <a href="{{ privacyPolicyUrl() }}" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                </label>
              </div>
              @if (submitted && form.get('accept_privacy_policy')?.errors) {
                <div>
                  @if (form.get('accept_privacy_policy')?.errors?.['required']) {
                    <div i18n="signup|Accept privacy policy required error">You must accept the Privacy Policy</div>
                  }
                </div>
              }
            </div>
          </div>

          <div class="flex flex-col gap-1">
            <p-button type="submit" [disabled]="submitted && !form.valid" i18n="signup|Register button">Register</p-button>
          </div>
        </form>
      </div>
    }
  </div>

  <app-footer-links></app-footer-links>
</div>
